import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import LoadingErrorWrapper from "../../components/Loading/Loading";
import PerfilContainer from "../../components/PerfilContainer/PerfilContainer";
import DevolveContainer from "./DevolveContainer";

const DemoPageContent = ({ pathname, user, loadingUser, errorUser }) => {
    if (errorUser) return <Typography>Erro ao carregar usuário</Typography>;
    return (
        <LoadingErrorWrapper loading={loadingUser} error={errorUser}>
        {pathname === "/perfil/devolve" ? (
            <DevolveContainer userId={user?.id} />
        ) : (
            <PerfilContainer user={user} />
        )}
        </LoadingErrorWrapper>
    );
};
DemoPageContent.propTypes = {
    pathname: PropTypes.string.isRequired,
    user: PropTypes.object,
    loadingUser: PropTypes.bool.isRequired,
    errorUser: PropTypes.bool.isRequired,
};

export default DemoPageContent;